import type {
  BenefitItem,
  CtaData,
  FeatureItem,
  FooterSection,
  HeroData,
  NavItem,
  RoleItem,
} from "./types";

export const navItems: NavItem[] = [
  { label: "Features", href: "#features" },
  { label: "Roles", href: "#roles" },
  { label: "Contact", href: "#contact" },
];

export const heroData: HeroData = {
  title: "Streamline Your Workforce with Liriworks",
  description:
    "A comprehensive platform for managing employees, tasks, payroll, timesheets, and more. Boost productivity and centralize your operations.",
  primaryCta: { label: "Get Started", href: "/registration" },
  secondaryCta: { label: "Sign In", href: "/login" },
  stats: [
    {
      label: "Employees",
      value: "156",
      valueClassName: "text-[#2a62e6]",
      cardClassName: "bg-[#edf2fb]",
    },
    {
      label: "Attendance",
      value: "89%",
      valueClassName: "text-[#0d9a55]",
      cardClassName: "bg-[#e5f2eb]",
    },
    {
      label: "Projects",
      value: "24",
      valueClassName: "text-[#7a3ef0]",
      cardClassName: "bg-[#efe9f8]",
    },
  ],
};

export const features: FeatureItem[] = [
  {
    icon: "Users",
    title: "Employee Management",
    description:
      "Manage employee profiles, skills, and organizational hierarchy in one place.",
  },
  {
    icon: "Kanban",
    title: "Task & Project Tracking",
    description:
      "Organize work with Kanban boards, list views, and real-time collaboration tools.",
  },
  {
    icon: "Calendar",
    title: "Leave Management",
    description:
      "Streamline leave requests, approvals, and balance tracking with automated workflows.",
  },
  {
    icon: "Clock",
    title: "Timesheet Tracking",
    description:
      "Track working hours, overtime, and project time with calendar-based timesheets.",
  },
  {
    icon: "Package",
    title: "Inventory Management",
    description:
      "Manage company assets, equipment allocation, and inventory with complete visibility.",
  },
  {
    icon: "ClipboardList",
    title: "Reimbursement Workflows",
    description:
      "Process expense claims with approval workflows and automatic notifications.",
  },
  {
    icon: "Settings",
    title: "Shift & Roster Management",
    description:
      "Create and manage employee schedules, shifts, and roster planning effortlessly.",
  },
  {
    icon: "Award",
    title: "Performance Reviews",
    description:
      "Conduct reviews, gather feedback, and track employee performance over time.",
  },
  {
    icon: "BarChart3",
    title: "Analytics & Reports",
    description:
      "Gain insights with comprehensive reports and analytics dashboards.",
  },
  {
    icon: "DollarSign",
    title: "Salary Management",
    description:
      "Manage payroll, salary structures, increments, and compensation with transparency.",
  },
  {
    icon: "Activity",
    title: "Employee Work Tracking",
    description:
      "Monitor employee productivity, task completion, and progress in real-time.",
  },
];

export const roles: RoleItem[] = [
 {
    icon: "Settings",
    title: "System Admin",
    colorClassName: "bg-[#e05a9a]",
    iconWrapperClassName: "bg-[#fceef6]",
    bulletClassName: "bg-[#e05a9a]",
    points: [
      "Complete system control",
      "Database and infrastructure management",
      "Security and compliance settings",
      "System-wide configurations",
    ],
  },
  {
    icon: "Shield",
    title: "Admin",
    colorClassName: "bg-[#2563eb]",
    iconWrapperClassName: "bg-[#eef3fc]",
    bulletClassName: "bg-[#2563eb]",
    points: [
      "Full system access and configuration",
      "User and role management",
      "Analytics and reporting",
      "Policy and workflow setup",
    ],
  },
  {
    icon: "UserCheck",
    title: "Manager",
    colorClassName: "bg-[#0ea35d]",
    iconWrapperClassName: "bg-[#edf7f2]",
    bulletClassName: "bg-[#0ea35d]",
    points: [
      "Team management and oversight",
      "Approve leave and reimbursements",
      "Assign tasks and projects",
      "Performance evaluations",
    ],
  },
  {
    icon: "Users",
    title: "Employee",
    colorClassName: "bg-[#7a3ef0]",
    iconWrapperClassName: "bg-[#f3eefe]",
    bulletClassName: "bg-[#7a3ef0]",
    points: [
      "View and update profile",
      "Submit leave and expense requests",
      "Track tasks and timesheets",
      "Access payslips and documents",
    ],
  },
];

export const benefits: BenefitItem[] = [
  {
    icon: "Zap",
    title: "Improve Productivity",
    description: "Automate repetitive tasks and focus on strategic initiatives",
    iconWrapperClassName: "bg-[#2563eb]",
  },
  {
    icon: "Target",
    title: "Centralized Operations",
    description: "All functions in one unified platform",
    iconWrapperClassName: "bg-[#08a652]",
  },
  {
    icon: "TrendingUp",
    title: "Transparent Workflows",
    description: "Clear visibility into processes and approvals",
    iconWrapperClassName: "bg-[#8a1ee8]",
  },
  {
    icon: "Calendar",
    title: "Workforce Planning",
    description: "Smart scheduling and resource allocation",
    iconWrapperClassName: "bg-[#f25705]",
  },
];

export const ctaData: CtaData = {
  title: "Ready to Transform Your Workforce?",
  subtitle: "Join hundreds of companies streamlining their workforce management",
  primaryButton: { label: "Start Free Trial", href: "/registration" },
  secondaryButton: { label: "Quick Enquiry", href: "#quick-inquiry" },
};

export const footerSections: FooterSection[] = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "#features" },
      { label: "Who can use?", href: "#roles" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "#about" },
      // { label: "Contact", href: "#contact" },
      { label: "Quick Enquiry", href: "#quick-inquiry" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms of Service", href: "/terms-of-service" },
      // { label: "Security", href: "#security" },
    ],
  },
];